
const digest = '9ea3cda5f217e976a96a326eb5460bd6422a6e4d12f65c5c7f894680f3d2c7c2';
const classes = {"wrapper":"_wrapper_11p1w_1","header":"_header_11p1w_5","title":"_title_11p1w_11","textarea":"_textarea_11p1w_17"};
const css = `._wrapper_11p1w_1 {
  padding: 32px 24px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
}
._wrapper_11p1w_1 ._header_11p1w_5 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
._wrapper_11p1w_1 ._header_11p1w_5 ._title_11p1w_11 {
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 16px;
}
._wrapper_11p1w_1 ._textarea_11p1w_17 {
  min-height: 194px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  